import { eTipoPermissao } from '@/enums/ePermissoes';
import { eModeloComprovante } from '@/enums/eDeclaracao';

/*
 * COMPROVANTES DE MATRÍCULA — migração de `EmitirComprovante.aspx`.
 *
 * Uma tela, uma rota por modelo — o mesmo motivo das declarações: o menu do legado abre a tela
 * nova por `/proxylegado/<nome>` e a query string não atravessa.
 *
 * Os modelos 4, 5 e 6 do legado (certificado de conclusão do EJA, requerimento de matrícula e
 * ficha de matrícula) nasceram para as redes de Contagem e Magé e ficaram fora do escopo desta
 * migração — por isso não há rota para eles.
 *
 * As permissões são as do LEGADO, a pedido; a estrutura definitiva será desenhada à mão.
 */
export default [
  {
    description: 'Comprovante de Matrícula',
    path: '/academico/comprovante/matricula',
    name: 'comprovante_matricula',
    component: () => import('@/views/academico/declaracao/Comprovante.vue'),
    meta: {
      permissions: [eTipoPermissao.COMPROVANTEDEMATRICULANOVO_MENU_300201199],
      modeloComprovante: eModeloComprovante.ComprovanteMatricula,
    },
    goesToMenu: true,
  },
  {
    description: 'Declaração de Matrícula',
    path: '/academico/comprovante/declaracao-matricula',
    name: 'comprovante_declaracao_matricula',
    component: () => import('@/views/academico/declaracao/Comprovante.vue'),
    meta: {
      permissions: [eTipoPermissao.DECLARACAODEMATRICULANOVO_MENU_300700499],
      modeloComprovante: eModeloComprovante.DeclaracaoMatricula,
    },
    goesToMenu: true,
  },
  {
    description: 'Trajetória de Matrícula',
    path: '/academico/comprovante/trajetoria',
    name: 'comprovante_trajetoria',
    component: () => import('@/views/academico/declaracao/Comprovante.vue'),
    meta: {
      permissions: [eTipoPermissao.TRAJETORIADEMATRICULANOVO_MENU_300201399],
      modeloComprovante: eModeloComprovante.TrajetoriaMatricula,
    },
    goesToMenu: true,
  },
];
